module.exports = "<div class=q-marg-all-lg> <div class=q-marg-vert-md> <div class=\"q-alert q-alert-red\"> Progress will be lost if continuing. </div> </div> <div class=q-marg-bottom-md> Once this new organization has been created it will appear as an option to select within this list. PLEASE NOTE: By continuing to create a new organization you will be redirected to a new page and will lose all progress made on this form. </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/addressBook/html/createOrganization/createOrganizationModal.html
// module id = 1180
// module chunks = 1